export default "__VITE_ASSET__DGVWMr$n__"